import React from 'react';
import { cn } from '../../../lib/utils';
import {
  attachmentTextExtractionDotClass,
  attachmentTextExtractionHint,
  matchPersistedEmailAttachment,
  type AttachmentTextExtractionStatus,
  type PersistedEmailAttachmentRow,
} from '../utils/attachmentTextExtraction';
import type { EmailAttachment } from '../utils/attachments';

interface AttachmentTextExtractionDotProps {
  index: number;
  meta: EmailAttachment;
  emailAttachments: PersistedEmailAttachmentRow[] | undefined | null;
  className?: string;
}

/**
 * Small status dot (top-left of attachment chip) for text-extraction pipeline state.
 */
const AttachmentTextExtractionDot: React.FC<AttachmentTextExtractionDotProps> = ({
  index,
  meta,
  emailAttachments,
  className,
}) => {
  const row = matchPersistedEmailAttachment(index, meta, emailAttachments);
  if (!row) return null;

  const status = row.textExtractionStatus as AttachmentTextExtractionStatus;
  const hint = attachmentTextExtractionHint(status, row.textExtractionError);
  const dotClass = attachmentTextExtractionDotClass(status);

  return (
    <span
      className={cn(
        'absolute -top-1 -left-1 z-10 h-2.5 w-2.5 rounded-full border-2 border-white shadow-sm dark:border-gray-900',
        dotClass,
        className,
      )}
      title={hint}
      aria-label={hint}
      role="img"
    />
  );
};

export default AttachmentTextExtractionDot;
